import partial from 'lodash/partial'
import React from 'react'
import {Link} from 'react-router-dom'

import * as URLS from '../../../urls'
import * as track from '../../../track/other'
import {NearestShowroomLocation} from '../../../typedefs/showrooms'

import '../../../../scss/components/landing/_nearest-showroom-banner.scss'

interface Props {
  nearestShowroomLocation: NearestShowroomLocation
}

const NearestShowroomLocationBanner: React.FC<Props> = ({nearestShowroomLocation}) => {
  const {city, slug, state} = nearestShowroomLocation

  return (
    <div className="c-nearest-sr-banner">
      <div className="c-nearest-sr-banner__inner">
        <Link
          className="c-nearest-sr-banner__content"
          onClick={partial(track.clickedLink, {
            location: 'Site header',
            target: `${URLS.SHOWROOMS}/${slug}`,
          })}
          to={`${URLS.SHOWROOMS}/${slug}`}
        >
          <p className="c-nearest-sr-banner-layout">
            <span className="c-nearest-sr-banner__label">
              Get fit & style advice at your nearest showroom:
            </span>
            <span className="c-nearest-sr-banner__location">
              {city}, {state}
            </span>
          </p>
        </Link>
      </div>
    </div>
  )
}

export default NearestShowroomLocationBanner
